import { render, staticRenderFns } from "./CourseTripsTable.vue?vue&type=template&id=66e2c489"
import script from "./CourseTripsTable.vue?vue&type=script&lang=js"
export * from "./CourseTripsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports